export enum PermissionEnum {
  PROJECTS_DOSSIER = "PROJECTS_DOSSIER",
  PROJECTS_PROJECT = "PROJECTS_PROJECT",
  PROJECTS_WORKSHEET = "PROJECTS_WORKSHEET",
  PROJECTS_QUICK_WORKSHEET = "PROJECTS_QUICK_WORKSHEET",
  PROJECT_WORKSHEET_VALIDATION = "PROJECT_WORKSHEET_VALIDATION",
  PROJECTS_FILES = "PROJECTS_FILES",
  PROJECTS_EXPENSES = "PROJECTS_EXPENSES",
  PROJECTS_ECONOMIC_ANALYSIS = "PROJECTS_ECONOMIC_ANALYSIS",
  PROJECT_CALENDAR = "PROJECT_CALENDAR",
  PROJECTS_ON_CALL = "PROJECTS_ON_CALL",
  PROJECTS_TASK_FILES = "PROJECTS_TASK_FILES",
  PROJECT_REPORT_TEMPLATE = "PROJECT_REPORT_TEMPLATE",
  PROJECT_TECHNICAL_REPORT = "PROJECT_TECHNICAL_REPORT",

  SUPERVISION_TIMES_OFF = "SUPERVISION_TIMES_OFF",
  SUPERVISION_WORKSHEET = "SUPERVISION_WORKSHEET",
  SUPERVISION_ON_CALL = "SUPERVISION_ON_CALL",
  /* @Deprecated() */ SUPERVISION_EXPENSES = "SUPERVISION_EXPENSES",

  CERTIFICATIONS_PROJECTS = "CERTIFICATIONS_PROJECTS",
  CERTIFICATIONS_DETAIL = "CERTIFICATIONS_DETAIL",
  CERTIFICATIONS_DELIVERIES = "CERTIFICATIONS_DELIVERIES",

  SCHEDULER_CALENDAR = "SCHEDULER_CALENDAR",
  SCHEDULER_ORP = "SCHEDULER_ORP",
  SCHEDULER_ORP_CONFIGURATION = "SCHEDULER_ORP_CONFIGURATION",
  SCHEDULER_QUALIFICATIONS_REPORT = "SCHEDULER_QUALIFICATIONS_REPORT",
  SCHEDULER_PLANNING_BOARD = "SCHEDULER_PLANNING_BOARD",
  SCHEDULER_PLANNING_BOARD_ALL_BUSINESS_UNITS = "SCHEDULER_PLANNING_BOARD_ALL_BUSINESS_UNITS",
  SCHEDULER_PLANNING_BOARD_EDIT = "SCHEDULER_PLANNING_BOARD_EDIT",

  FLEET_VEHICLES = "FLEET_VEHICLES",
  FLEET_VEHICLES_ISSUES = "FLEET_VEHICLES_ISSUES",
  FLEET_VEHICLES_USAGE = "FLEET_VEHICLES_USAGE",
  FLEET_VEHICLE_TYPE_CHECKLIST = "FLEET_VEHICLE_TYPE_CHECKLIST",

  HR_TIMES_OFF = "HR_TIMES_OFF",
  HR_EMPLOYEES = "HR_EMPLOYEES",
  HR_PAYROLLS = "HR_PAYROLLS",
  HR_TIMES_OFF_VALIDATION = "HR_TIMES_OFF_VALIDATION",
  HR_POSTS = "HR_POSTS",
  HR_CONFIGURATION = "HR_CONFIGURATION",
  HR_UPDATE_TECHNICIAN_COSTS = "HR_UPDATE_TECHNICIAN_COSTS",
  HR_EMPLOYEE_DOCUMENTS = "HR_EMPLOYEE_DOCUMENTS",
  HR_ONBOARDING = "HR_ONBOARDING",

  WAREHOUSE_WAREHOUSES = "WAREHOUSE_WAREHOUSES",
  WAREHOUSE_CONSUMABLES = "WAREHOUSE_CONSUMABLES",
  WAREHOUSE_CONSUMABLES_CREATE = "WAREHOUSE_CONSUMABLES_CREATE",
  WAREHOUSE_ITEMS = "WAREHOUSE_ITEMS",
  WAREHOUSE_ITEMS_CREATE = "WAREHOUSE_ITEMS_CREATE",
  WAREHOUSE_SERVICES = "WAREHOUSE_SERVICES",
  WAREHOUSE_SERVICES_CREATE = "WAREHOUSE_SERVICES_CREATE",
  WAREHOUSE_STOCK_RECORDS = "WAREHOUSE_STOCK_RECORDS",
  WAREHOUSE_CONFIG_SUPPLIERS = "WAREHOUSE_CONFIG_SUPPLIERS",
  WAREHOUSE_CONFIGURATION = "WAREHOUSE_CONFIGURATION",
  WAREHOUSE_ISSUES = "WAREHOUSE_ISSUES",
  WAREHOUSE_PURCHASE_ORDERS = "WAREHOUSE_PURCHASE_ORDERS",
  WAREHOUSE_PURCHASE_ORDER_APPROVAL_BASIC = "WAREHOUSE_PURCHASE_ORDER_APPROVAL_BASIC",
  WAREHOUSE_PURCHASE_ORDER_APPROVAL_MEDIUM = "WAREHOUSE_PURCHASE_ORDER_APPROVAL_MEDIUM",
  WAREHOUSE_PURCHASE_ORDER_APPROVAL_ADVANCED = "WAREHOUSE_PURCHASE_ORDER_APPROVAL_ADVANCED",
  WAREHOUSE_PURCHASE_ORDER_APPROVAL_EXPERT = "WAREHOUSE_PURCHASE_ORDER_APPROVAL_EXPERT",
  WAREHOUSE_PURCHASE_ORDER_APPROVAL_MASTER = "WAREHOUSE_PURCHASE_ORDER_APPROVAL_MASTER",
  WAREHOUSE_PURCHASE_ORDER_APPROVAL_CONFIGURATION = "WAREHOUSE_PURCHASE_ORDER_APPROVAL_CONFIGURATION",
  WAREHOUSE_PURCHASE_ORDER_CANCEL = "WAREHOUSE_PURCHASE_ORDER_CANCEL",
  WAREHOUSE_DELIVERY_NOTES = "WAREHOUSE_DELIVERY_NOTES",
  WAREHOUSE_DELIVERY_NOTES_ADJUST_PRICES = "WAREHOUSE_DELIVERY_NOTES_ADJUST_PRICES",

  ACCOUNTING_ACCOUNTING = "ACCOUNTING_ACCOUNTING",

  REPORTS_GROUP_BY = "REPORTS_GROUP_BY",
  REPORTS_USER_ACTIVITY = "REPORTS_USER_ACTIVITY",
  REPORTS_TIMES_OFF = "REPORTS_TIME_OFF",
  REPORTS_PERMISSIONS = "REPORTS_PERMISSIONS",
  REPORTS_PROFITABILITY = "REPORTS_PROFITABILITY",
  REPORTS_ALLOCATION_COST = "REPORTS_ALLOCATION_COST",
  REPORTS_AI = "REPORTS_AI",

  CONFIGURATION_ORGANIZATION = "CONFIGURATION_ORGANIZATION",
  CONFIGURATION_ACCOUNTING = "CONFIGURATION_ACCOUNTING",
  CONFIGURATION_COMMERCIAL = "CONFIGURATION_COMMERCIAL",
  CONFIGURATION_STRUCTURE = "CONFIGURATION_STRUCTURE",
  CONFIGURATION_FILES = "CONFIGURATION_FILES",
  CONFIGURATION_WORKSHEETS = "CONFIGURATION_WORKSHEETS",
  CONFIGURATION_ACCESS = "CONFIGURATION_ACCESS",
  USERS_CREATE = "USERS_CREATE",
  CONFIGURATION_ZONES = "CONFIGURATION_ZONES",

  NOTIFY_ERROR = "NOTIFY_ERROR",

  SUPPLIER_INVOICES = "SUPPLIER_INVOICES",

  MCP_CONNECTION = "MCP_CONNECTION",
}

export const hasPermission = (value: PermissionEnum, permissions: PermissionEnum[]): boolean => {
  const permissionIndex = permissions.indexOf(value);
  return permissionIndex >= 0;
};

export const getPermissionsLabel = (permission: PermissionEnum): string => {
  switch (permission) {
    case PermissionEnum.PROJECTS_DOSSIER:
      return "Expedientes";
    case PermissionEnum.PROJECTS_PROJECT:
      return "Proyectos";
    case PermissionEnum.PROJECTS_WORKSHEET:
      return "Partes";
    case PermissionEnum.PROJECTS_QUICK_WORKSHEET:
      return "Fichaje rápido";
    case PermissionEnum.PROJECT_WORKSHEET_VALIDATION:
      return "Validación de partes";
    case PermissionEnum.PROJECTS_EXPENSES:
      return "Gastos";
    case PermissionEnum.PROJECTS_FILES:
      return "Archivos";
    case PermissionEnum.PROJECTS_ECONOMIC_ANALYSIS:
      return "Análisis económico";
    case PermissionEnum.PROJECTS_ON_CALL:
      return "Guardias";
    case PermissionEnum.PROJECT_REPORT_TEMPLATE:
      return "Plantillas de informes";
    case PermissionEnum.PROJECT_TECHNICAL_REPORT:
      return "Informes técnicos";
    case PermissionEnum.PROJECTS_TASK_FILES:
      return "Archivos de tareas";
    case PermissionEnum.SUPERVISION_WORKSHEET:
      return "Supervisión de partes";
    case PermissionEnum.SUPERVISION_EXPENSES:
      return "Supervisión de gastos";
    case PermissionEnum.SUPERVISION_TIMES_OFF:
      return "Supervisión de ausencias";
    case PermissionEnum.SUPERVISION_ON_CALL:
      return "Supervisión de guardias";
    case PermissionEnum.CERTIFICATIONS_PROJECTS:
      return "Certificaciones";
    case PermissionEnum.CERTIFICATIONS_DETAIL:
      return "Detalle de certificación";
    case PermissionEnum.CERTIFICATIONS_DELIVERIES:
      return "Entregas";
    case PermissionEnum.SCHEDULER_CALENDAR:
      return "Planificador";
    case PermissionEnum.SCHEDULER_PLANNING_BOARD:
      return "Pizarra de planificación";
    case PermissionEnum.SCHEDULER_PLANNING_BOARD_ALL_BUSINESS_UNITS:
      return "Pizarra - todas las unidades de negocio";
    case PermissionEnum.SCHEDULER_PLANNING_BOARD_EDIT:
      return "Pizarra de planificación - Editar";
    case PermissionEnum.SCHEDULER_ORP:
      return "PRL - Prevención de Riesgos Laborales";
    case PermissionEnum.SCHEDULER_QUALIFICATIONS_REPORT:
      return "Informe de formaciones";
    case PermissionEnum.FLEET_VEHICLES:
      return "Vehículos";
    case PermissionEnum.FLEET_VEHICLES_ISSUES:
      return "Incidencias en vehículos";
    case PermissionEnum.FLEET_VEHICLES_USAGE:
      return "Uso de vehículos";
    case PermissionEnum.FLEET_VEHICLE_TYPE_CHECKLIST:
      return "Plantillas de checklist";
    case PermissionEnum.PROJECT_CALENDAR:
      return "Informe de calendario";
    case PermissionEnum.HR_POSTS:
      return "Comunicados";
    case PermissionEnum.HR_TIMES_OFF:
      return "Ausencias";
    case PermissionEnum.HR_EMPLOYEES:
      return "Empleados";
    case PermissionEnum.HR_PAYROLLS:
      return "Nóminas";
    case PermissionEnum.HR_TIMES_OFF_VALIDATION:
      return "Validación de ausencias";
    case PermissionEnum.WAREHOUSE_WAREHOUSES:
      return "Almacenes";
    case PermissionEnum.WAREHOUSE_CONSUMABLES:
      return "Consumibles";
    case PermissionEnum.WAREHOUSE_CONSUMABLES_CREATE:
      return "Consumibles - Crear";
    case PermissionEnum.WAREHOUSE_ITEMS:
      return "Artículos";
    case PermissionEnum.WAREHOUSE_ITEMS_CREATE:
      return "Artículos - Crear";
    case PermissionEnum.WAREHOUSE_SERVICES:
      return "Servicios";
    case PermissionEnum.WAREHOUSE_SERVICES_CREATE:
      return "Servicios - Crear";
    case PermissionEnum.WAREHOUSE_STOCK_RECORDS:
      return "Registros de stock";
    case PermissionEnum.WAREHOUSE_CONFIG_SUPPLIERS:
      return "Proveedores";
    case PermissionEnum.WAREHOUSE_PURCHASE_ORDERS:
      return "Pedidos de almacén";
    case PermissionEnum.WAREHOUSE_PURCHASE_ORDER_APPROVAL_BASIC:
      return "Aprobación de pedidos - básico";
    case PermissionEnum.WAREHOUSE_PURCHASE_ORDER_APPROVAL_MEDIUM:
      return "Aprobación de pedidos - medio";
    case PermissionEnum.WAREHOUSE_PURCHASE_ORDER_APPROVAL_ADVANCED:
      return "Aprobación de pedidos - avanzado";
    case PermissionEnum.WAREHOUSE_PURCHASE_ORDER_APPROVAL_EXPERT:
      return "Aprobación de pedidos - directivo";
    case PermissionEnum.WAREHOUSE_PURCHASE_ORDER_APPROVAL_MASTER:
      return "Aprobación de pedidos - máximo";
    case PermissionEnum.WAREHOUSE_PURCHASE_ORDER_APPROVAL_CONFIGURATION:
      return "Configuración de aprobación de permisos";
    case PermissionEnum.WAREHOUSE_PURCHASE_ORDER_CANCEL:
      return "Anular pedidos de almacén";
    case PermissionEnum.WAREHOUSE_DELIVERY_NOTES:
      return "Albaranes";
    case PermissionEnum.WAREHOUSE_DELIVERY_NOTES_ADJUST_PRICES:
      return "Albaranes - Ajustar precios";
    case PermissionEnum.WAREHOUSE_ISSUES:
      return "Incidencias en almacén";
    case PermissionEnum.REPORTS_GROUP_BY:
      return "Informe de horas/hombre";
    case PermissionEnum.REPORTS_USER_ACTIVITY:
      return "Informe de actividad de usuario";
    case PermissionEnum.REPORTS_TIMES_OFF:
      return "Informe de ausencias";
    case PermissionEnum.REPORTS_PERMISSIONS:
      return "Informe de permisos";
    case PermissionEnum.REPORTS_PROFITABILITY:
      return "Informe de rentabilidad";
    case PermissionEnum.REPORTS_ALLOCATION_COST:
      return "Informe de costes por cesión de recursos";
    case PermissionEnum.REPORTS_AI:
      return "Asistente IA";
    case PermissionEnum.CONFIGURATION_ORGANIZATION:
      return "Organización";
    case PermissionEnum.CONFIGURATION_ACCOUNTING:
      return "Contabilidad";
    case PermissionEnum.CONFIGURATION_COMMERCIAL:
      return "Comercial";
    case PermissionEnum.SCHEDULER_ORP_CONFIGURATION:
      return "Configuración PRL";
    case PermissionEnum.WAREHOUSE_CONFIGURATION:
      return "Configuración almacén";
    case PermissionEnum.HR_CONFIGURATION:
      return "Configuración recursos humanos";
    case PermissionEnum.HR_UPDATE_TECHNICIAN_COSTS:
      return "Actualizar costes de técnicos";
    case PermissionEnum.HR_EMPLOYEE_DOCUMENTS:
      return "Documentación del empleado";
    case PermissionEnum.HR_ONBOARDING:
      return "Onboarding";
    case PermissionEnum.CONFIGURATION_STRUCTURE:
      return "Estructura";
    case PermissionEnum.CONFIGURATION_FILES:
      return "Archivos";
    case PermissionEnum.CONFIGURATION_WORKSHEETS:
      return "Partes";
    case PermissionEnum.CONFIGURATION_ACCESS:
      return "Acceso";
    case PermissionEnum.USERS_CREATE:
      return "Usuarios - Crear";
    case PermissionEnum.CONFIGURATION_ZONES:
      return "Zonas";
    case PermissionEnum.NOTIFY_ERROR:
      return "Reportar error";
    case PermissionEnum.SUPPLIER_INVOICES:
      return "Facturas de proveedor";
    case PermissionEnum.ACCOUNTING_ACCOUNTING:
      return "Contabilidad";
    case PermissionEnum.MCP_CONNECTION:
      return "Conexión MCP";
    default:
      return "";
  }
};
